
import { useEffect, useState } from "react"
import Loding from "../Pages/Shared/Loding"
import { useQuery } from "react-query"
const useBookperParthook = id => {

    // const [parts, setPart] = useState({})
    // console.log(parts)
    // useEffect(() => {
    //     const url = `https://car-manufacture-server-side.onrender.com/part/${id}`
    //     fetch(url)
    //         .then(res => res.json())
    //         .then(data => setPart(data))
    // }, [id])
    const { data: parts, isLoading, refetch } = useQuery('partss', () => fetch(`https://car-manufacture-server-side.onrender.com/part/${id}`
    ).then(res => res.json()))


    return [parts, refetch, isLoading]


}
export default useBookperParthook;
